export const AppName = 'Finance Portal'

export type ArrayElement<T> = T extends (infer U)[] ? U : never
